import React from 'react';

const MicrosoftButton = ({ onClick, disabled, text = 'Continuar con Microsoft', style }) => {
  const buttonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    userSelect: 'none',
    backgroundColor: 'white',
    border: '1px solid #dcdcdc',
    borderRadius: '12px',
    boxSizing: 'border-box',
    color: '#3c4043',
    cursor: disabled ? 'not-allowed' : 'pointer',
    fontFamily: "'Roboto', Arial, sans-serif",
    fontSize: '16px',
    fontWeight: '500',
    height: '48px',
    padding: '26px 24px',
    outline: 'none',
    overflow: 'hidden',
    textAlign: 'center',
    transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
    whiteSpace: 'nowrap',
    width: 'auto',
    ...style
  };

  const iconStyle = {
    height: '24px',
    width: '24px',
    display: 'block'
  };

  const textStyle = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    fontWeight: '500',
    color: '#3c4043',
    marginLeft: '12px'
  };

  const buttonHoverStyle = {
    backgroundColor: '#f7f7f7'
  };

  return (
    <button
      style={buttonStyle}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={e => {
        if (!disabled) {
          Object.assign(e.currentTarget.style, buttonHoverStyle);
        }
      }}
      onMouseLeave={e => {
        if (!disabled) {
          Object.assign(e.currentTarget.style, buttonStyle);
        }
      }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={iconStyle}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            style={{ display: 'block', height: '24px', width: '24px' }}>
            <rect x="2" y="2" width="20" height="20" fill="#F25022" />
            <rect x="26" y="2" width="20" height="20" fill="#7FBA00" />
            <rect x="2" y="26" width="20" height="20" fill="#00A4EF" />
            <rect x="26" y="26" width="20" height="20" fill="#FFB900" />
          </svg>
        </div>
        <span style={textStyle}>{text}</span>
      </div>
    </button>
  );
};

export default MicrosoftButton;
